import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const session_id = m ? decodeURIComponent(m[1]) : null;
    if (!session_id) {
      nav("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        setUser(data.user);
        window.history.replaceState({}, "", "/");
        toast.success(`Olá, ${data.user.name?.split(" ")[0]}!`);
        // Honor an intent stashed by the Register page's Google signup CTA
        let target = "/";
        try {
          const intent = sessionStorage.getItem("rivendas_signup_intent");
          sessionStorage.removeItem("rivendas_signup_intent");
          if (intent === "seller") target = "/especialidades";
          else if (intent === "servico") target = "/create?type=servico";
          else if (intent === "trocar") target = "/create?type=permuta";
          else if (intent === "doar") target = "/create?type=doacao&direction=dar";
        } catch (err) {
          // sessionStorage is rare-fail (private mode / disabled storage).
          // We fall back to `/` — do not disrupt the auth callback for this.
          console.warn("AuthCallback: unable to read signup intent", err?.message);
        }
        nav(target, { replace: true });
      } catch (err) {
        console.warn("AuthCallback: /auth/session failed", err?.message);
        toast.error("Falha ao processar login. Tente novamente.");
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-muted-foreground">Autenticando...</p>
    </div>
  );
}
